module.exports = __webpack_public_path__ + "resources/img/img-hyper-frame-tomcat-03-jp.248c10db910ac9b753af73ef2a345d87.png";